<template>
    <div class="templete_box">
        <div class="templete">
            <!-- <div class="header_row clearfix">
                <div class="header_row_message">
                    <span>供应商：{{info.supplier}}</span>
                    <span>合同号：{{info.contract_no}}</span>
                    <span>提单号：{{info.bill_lading_no}}</span>
                </div>
                <div class="header_row_return">
                    返回列表
                </div>
            </div> -->
            <div class="search_box search_box_f clearfix">
                <el-input class="search_input search_inputBox" v-model="params.bale_no" :placeholder="'捆包号'"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.bill_lading_no" placeholder="提单号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.container_no" placeholder="货柜号" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getSelectList('breed')">
                    <el-option v-for="list in selectMap.breed" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getSelectList('brand')">
                    <el-option v-for="list in selectMap.brand" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.grade_id" multiple collapse-tags placeholder="等级" @visible-change="getSelectList('grade')">
                    <el-option v-for="list in selectMap.grade" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.attribute_id" collapse-tags placeholder="属性" @visible-change="getSelectList('attribute')">
                    <el-option v-for="list in selectMap.attribute" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.color_id" collapse-tags placeholder="选色" @visible-change="getSelectList('color')">
                    <el-option v-for="list in selectMap.color" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.thickness" placeholder="厚度"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.length" placeholder="长度"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.original_bale" placeholder="供单号" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.opening_company_id" placeholder="货权单位" @visible-change="getSelectList('opencompany')">
                    <el-option v-for="list in selectMap.opencompany" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.ex_order_no" placeholder="外商单号" size="mini"></el-input>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getDetailList()">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn" @click="detailObject.purchase_id=purchase_id;dialogVisible = !dialogVisible;detailType=2;detailObject.category=info.category;detailObject.contract_no=info.contract_no;detailObject.contract_time=parseInt(info.contract_time+'000');detailObject.supplier_id=info.supplier_id;">添加单条数据</el-button>
                <el-button class="funcPublicBtn" @click="batchEdit">批量修改</el-button>
                <el-button class="funcPublicBtn" @click="batchDel">批量删除</el-button>
                <div class="execlInsertBtnC execlInsertHasFilter clearfix">
                    <span class="excel_btn" @click="openimport()"><i class="excel-icon"></i>EXECL码单导入</span>
                </div>
                <div class="header_row_return" @click="backList">
                    返回列表
                </div>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="purchase.bales.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @getTableDelete="getTableDelete" @getTableSee="getTableSee" @getTableEdit="getTableEdit" @rowClick="rowClick"></tabletem>
            </div>
            <div class="totalCal">
                <div class="totalName">合计：</div>
                <div class="totalNumber" v-if="totalObj.total_count||Number(totalObj.total_count)==0">件数:{{totalObj.total_count}}</div>
                <div class="totalNumber" v-if="totalObj.total_cube||Number(totalObj.total_cube)==0">立方:{{totalObj.total_cube}}</div>
                <div class="totalNumber" v-if="totalObj.total_amount||Number(totalObj.total_amount)==0">总金额:{{totalObj.total_amount}}</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" @rowClick="rowClick" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogA" width="630px" :modal="false" :title="detailType==2?'新增数据':'修改数据'" custom-class="full_dialog">
            <!-- <div class="btnList clearfix" v-if="detailType==2" style="padding-bottom:10px;">
                <el-button :class="['funcPublicBtn',category==1?'funcPublicBtnChecked':'']" @click="category=1;detailObject.category=1;">非洲材</el-button>
                <el-button :class="['funcPublicBtn',category==2?'funcPublicBtnChecked':'']" @click="category=2;detailObject.category=2;">北美材</el-button>
            </div> -->
            <el-form :rules="batchEditType==2?detailObjectRules:detailObjectRulesBatch" ref="detailObjectForm" :model="detailObject" class="clearfix">
                <div class="eldialogFormBox">
                    <el-form-item  :label="'捆包号：'" prop="bale_no" v-if="fields.indexOf(',bale_no,')!=-1&&batchEditType==2">
                        <el-input v-model="detailObject.bale_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="供应商：" prop="supplier_id" v-if="fields.indexOf(',supplier,')!=-1">
                        <el-select v-model="detailObject.supplier_id" :disabled="true"  @visible-change="getSelectList('supplier')" filterable>
                            <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  :label="'品名：'" prop="breed_id" v-if="fields.indexOf(',breed,')!=-1">
                        <el-select v-model="detailObject.breed_id" @visible-change="getSelectList('breed')">
                            <el-option v-for="list in selectMap.breed" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="品牌：" prop="brand_id" v-if="fields.indexOf(',brand,')!=-1">
                        <el-select v-model="detailObject.brand_id" @visible-change="getSelectList('brand')">
                            <el-option v-for="list in selectMap.brand" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  :label="'厚度：'" prop="thickness" v-if="fields.indexOf(',thickness,')!=-1">
                        <el-input v-model="detailObject.thickness"></el-input>
                    </el-form-item>
                    <el-form-item  label="等级：" prop="grade_id" v-if="fields.indexOf(',grade,')!=-1">
                        <el-select v-model="detailObject.grade_id" @visible-change="getSelectList('grade')">
                            <el-option v-for="list in selectMap.grade" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="编码：" v-if="fields.indexOf(',code,')!=-1">
                        <el-input v-model="detailObject.code"></el-input>
                    </el-form-item>
                    <el-form-item  label="长度：" prop="length" v-if="fields.indexOf(',length,')!=-1">
                        <el-input v-model="detailObject.length"></el-input>
                    </el-form-item>
                    <el-form-item  label="片数：" prop="pieces" v-if="fields.indexOf(',pieces,')!=-1">
                        <el-input v-model="detailObject.pieces"></el-input>
                    </el-form-item>
                    <el-form-item  label="层数：" v-if="fields.indexOf(',layer_number,')!=-1">
                        <el-input v-model="detailObject.layer_number"></el-input>
                    </el-form-item>
                    <el-form-item  label="板尺：" prop="plate_ruler" v-if="fields.indexOf(',plate_ruler,')!=-1">
                        <el-input v-model="detailObject.plate_ruler"></el-input>
                    </el-form-item>
                    <el-form-item  label="属性：" prop="attribute_id" v-if="fields.indexOf(',attribute,')!=-1">
                        <el-select v-model="detailObject.attribute_id" @visible-change="getSelectList('attribute')">
                            <el-option v-for="list in selectMap.attribute" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="选色：" prop="color_id" v-if="fields.indexOf(',color,')!=-1">
                        <el-select v-model="detailObject.color_id" @visible-change="getSelectList('color')">
                            <el-option v-for="list in selectMap.color" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="货权单位：" prop="opening_company_id" v-if="fields.indexOf(',opening_company,')!=-1">
                        <el-select v-model="detailObject.opening_company_id" @visible-change="getSelectList('opencompany')">
                            <el-option v-for="list in selectMap.opencompany" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="供单号：" v-if="fields.indexOf(',original_bale,')!=-1">
                        <el-input v-model="detailObject.original_bale"></el-input>
                    </el-form-item>
                    <el-form-item  label="币种：" prop="foreign_currency_id" v-if="fields.indexOf(',foreign_currency_name,')!=-1">
                        <el-select v-model="detailObject.foreign_currency_id" @visible-change="getSelectList('currency')">
                            <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="外币单价：" prop="foreign_currency_price" v-if="fields.indexOf(',foreign_currency_price,')!=-1&&module.indexOf(',purchase-cost,')!=-1">
                        <el-input v-model="detailObject.foreign_currency_price"></el-input>
                    </el-form-item>
                    <el-form-item  label="汇率：" v-if="fields.indexOf(',foreign_exchange_rate,')!=-1">
                        <el-input v-model="detailObject.foreign_exchange_rate"></el-input>
                    </el-form-item>
                    <el-form-item  label="码单立方：" prop="cube" v-if="fields.indexOf(',cube,')!=-1">
                        <el-input v-model="detailObject.cube"></el-input>
                    </el-form-item>
                    <el-form-item  label="采购单价：" prop="cube_price" v-if="fields.indexOf(',cube_price,')!=-1&&module.indexOf(',purchase-cost,')!=-1">
                        <el-input v-model="detailObject.cube_price"></el-input>
                    </el-form-item>
                    <el-form-item  label="销售单价：" prop="sales_price" v-if="fields.indexOf(',sales_price,')!=-1">
                        <el-input v-model="detailObject.sales_price"></el-input>
                    </el-form-item>
                    <el-form-item  label="目的港：" prop="port_id" v-if="fields.indexOf(',purpose_port,')!=-1">
                        <el-select v-model="detailObject.port_id" @visible-change="getSelectList('port')">
                            <el-option v-for="list in selectMap.port" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="合同号：" prop="contract_no" v-if="fields.indexOf(',contract_no,')!=-1&&batchEditType==2">
                        <el-input v-model="detailObject.contract_no" :readonly="true"></el-input>
                    </el-form-item>
                    <el-form-item  label="预计入库：" prop="expected_storage_time" v-if="fields.indexOf(',expected_storage_time,')!=-1">
                        <el-date-picker v-model="detailObject.expected_storage_time" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="提单号：" prop="bill_lading_no" v-if="fields.indexOf(',bill_lading_no,')!=-1">
                        <el-input v-model="detailObject.bill_lading_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="预计到港：" prop="expected_arrival_time" v-if="fields.indexOf(',expected_arrival_time,')!=-1">
                        <el-date-picker v-model="detailObject.expected_arrival_time" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="货柜号：" prop="container_no" v-if="fields.indexOf(',container_no,')!=-1">
                        <el-input v-model="detailObject.container_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark" v-if="fields.indexOf(',remark,')!=-1">
                        <el-input v-model="detailObject.remark"></el-input>
                    </el-form-item>

                    <!-- <el-form-item  label="合同日期：" prop="contract_time">
                        <el-date-picker v-model="detailObject.contract_time" :readonly="true" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="产地：" prop="place_origin">
                        <el-input v-model="detailObject.place_origin"></el-input>
                    </el-form-item>
                    <el-form-item  label="立方：" prop="cube">
                        <el-input v-model="detailObject.cube"></el-input>
                    </el-form-item>
                    <el-form-item  label="总金额：" prop="total_amount">
                        <el-input v-model="detailObject.total_amount"></el-input>
                    </el-form-item> -->
                </div>
            </el-form>
            <!-- <div class="widthListBox" v-if="detailObject.category==1">
                <div class="title">宽度</div>
                <div class="widthList">
                    <div class="widthsList">
                        <div class="widthBox" v-for="(wi,index) in detailObject.width" :key="index">
                            <el-input type="text" v-model="detailObject.width[index]" class="widths"></el-input>
                            <div class="delWidth" @click="delWidth(index)"></div>
                        </div>
                    </div>
                    <div class="addWidth" @click="addWidth"></div>
                </div>
            </div> -->
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="add">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisible=!dialogVisible">关闭</el-button>
            </div>
        </el-dialog>
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleB" class="eldialog no_print eldialogLine auto" width="430px" :modal="false" :title="detailType==2?'新增数据':'修改数据'" custom-class="full_dialog">
            <el-form :rules="batchEditType==2?detailObjectRules:detailObjectRulesBatch" ref="detailObjectForm" :model="detailObject" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item  label="币种：" prop="foreign_currency_id" v-if="fields.indexOf(',foreign_currency_name,')!=-1">
                        <el-select v-model="detailObject.foreign_currency_id" @visible-change="getSelectList('currency')">
                            <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="外币单价：" prop="foreign_currency_price" v-if="fields.indexOf(',foreign_currency_price,')!=-1&&module.indexOf(',purchase-cost,')!=-1">
                        <el-input v-model="detailObject.foreign_currency_price"></el-input>
                    </el-form-item>
                    <el-form-item  label="汇率：" prop="foreign_exchange_rate" v-if="fields.indexOf(',foreign_exchange_rate,')!=-1">
                        <el-input v-model="detailObject.foreign_exchange_rate"></el-input>
                    </el-form-item>
                    <el-form-item  label="采购单价：" prop="cube_price" v-if="fields.indexOf(',cube_price,')!=-1&&module.indexOf(',purchase-cost,')!=-1">
                        <el-input v-model="detailObject.cube_price"></el-input>
                    </el-form-item>
                </div>
                <span class="remark tipFont">已入库的数据选中修改，只同步至应付采购单；若须同步至库存，需到库存管理检索再次修改。</span>
            </el-form>
             <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisibleB=!dialogVisibleB">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="add">确定</el-button>
            </div>
        </el-dialog>
        <!-- <div class="statistics">
            <span>合计：</span>
            <span>$外币总金额：312312</span>
            <span>￥总金额：312312</span>
        </div> -->
        <!--execl START-->
        <el-dialog v-dialog-drag title="码单导入" :visible.sync="importDialogVisible" class="eldialog eldialogExcel" :modal="false" width='680px'>
			<div class="text-center"  style="margin-top:20px;">
                <div class="tab_box">
                    <div v-if="boardAmericaType" :class="{active: active == 1 }" @click="active=1">北美材码单模板</div>
                    <div v-if="boardZelkovaType" :class="{active: active == 2 }" @click="active=2">榉木码单模板</div>
                    <div v-if="boardAfricaType" :class="{active: active == 3 }" @click="active=3">非洲材码单模板</div>
                    <div v-if="categoryRawType" :class="{active: active == 4 }" @click="active=4">原木码单模板</div>
                    <div v-if="nationalStandardType" :class="{active: active == 5 }" @click="active=5">国标/非洲材码单模板</div>
                </div>
                <div class="text-center relative" style="padding: 80px 150px 65px;">
                    <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".xls,.xlsx">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text"  style="font-size:12px; color:#333;">将文件拖到此处，或<em style="color: #b21111;text-decoration: underline;">导入上传码单</em></div>
                        <div class="el-upload__tip" slot="tip"  style="color: #888;margin-top:5px;">只能上传Excel文件</div>
                    </el-upload>
                    <div class="">
                        <el-link type="primary" @click='downTemplete' style="color:#b21111;font-weight:bold; cursor:pointer;text-decoration: underline;">下载码单模板</el-link>
                    </div>
                </div>
			</div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="importFile">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="importDialogVisible=!importDialogVisible">取消</el-button>
            </div>
		</el-dialog>
        <!--execl END-->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="purchase.bales.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="true" :list="widthList" :dialogvisible="dialogVisibleWidth" @returnwidth="res=>{this.widthObj.widthList=res;this.widthEditT();}" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
    </div>
</template>
<style scoped lang="scss">
    .widthListBox{margin-bottom:10px;
        .title{width:100%;background-color: #e4e4e4;text-align: center;font-size: 13px;color: #777;padding:5px 0;}
        .widthList{padding-right:25px;position: relative;
            .widthsList{display: flex;height:25px;width:100%;
                .widthBox{flex:1;height:25px;position: relative;
                    .widths{width:100%;height: 25px;border:1px solid #e4e4e4;font-size: 12px;line-height: 25px;}
                    .delWidth{width:10px;height:10px;position: absolute;top:0;right:0;background: url('../../assets/top-delete-suspension.png') no-repeat 100% 100%;background-size: 100% 100%;cursor: pointer;}
                }
            }
            .addWidth{width:25px;height:25px;position: absolute;top:0;right:0;background: url('../../assets/addWidth.png') no-repeat 50% 50%;background-size: 70% 70%;cursor: pointer;}
        }
    }
    .header_row{padding:10px 0;}
    .header_row_message{float: left;font-size: 12px;color:#777;
        span{margin-right:10px;}
    }
    .header_row_return{float: right;font-size: 14px;font-weight: 600;}
    .delWidth{width:10px;height:10px;position: absolute;top:0;right:0;background: url('../../assets/top-delete-suspension.png') no-repeat 100% 100%;background-size: 100% 100%;cursor: pointer;}
    .addWidth{position: relative; width:32px;height:32px;float:left;background: url('../../assets/addWidth.png') no-repeat 50% 50%;background-size: 70% 70%;cursor: pointer;}
    .tab_box{
        display: flex; align-items: center; border-bottom: 2px solid #EEEEEE; padding-bottom: 11px;
        & > div{
            width: 150px; text-align: center; padding: 8px 0; border:1px solid #707070; border-radius:3px; cursor: pointer; font-size: 14px;
            & + div{ margin-left: 30px; }
            &.active{ background: #B21111; color: #fff; border:1px solid #B21111; }
        }
    }
    .remark{text-align: center;color: #777;margin: 0 auto;display: block;}
</style>
<script>
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    export default {
        components:{
            tabletem,
            pagination
        },
        data(){
            return{
                module:localStorage.dw_erp_power_code,
                tableLoading:false,
                isShowMore:false,
                typeBale:2,//2板材 3原木
                importDialogVisible:false,
                upload_data : {},
				oss : {
                    host : "",
                },
				file_url : '',
                info:{
                    bill_lading_no: "",
                    container_no: "",
                    supplier: "",
                    tpl_code:"",
                    wood_type:"",
                    category:""
                },
                widthList:[],
                tab : 1,
                category:1,//1非洲材, 2北美材
                detailType:2,//2新增 3修改
                batchEditType:2,//2单条修改 3批量修改
                params:{
                    page:1,
                    per_page: 50,
                    purchase_id:"",
                    bale_no:"",
                    bill_lading_no:"",
                    brand_id:[],
                    breed_id:[],
                    thickness:"",
                    length:"",
                    attribute_id:"",
                    color_id:"",
                    opening_company_id:"",
                    original_bale:"",
                    container_no:"",
                    ex_order_no:"",
                    grade_id:[]
                },
                purchase_id:"",
                selectMap:{
                    breed:[],
                    brand:[],
                    grade:[],
                    supplier:[],
                    port:[],
                    color:[],
                    attribute:[],
                    opencompany:[],
                    currency:[]
                },
                dialogVisible:false,
                detailObject:{
                    id:"",
                    purchase_id:"",
                    contract_no:"",
                    contract_time:"",
                    supplier_id:"",
                    bill_lading_no:"",
                    container_no:"",
                    place_origin:"",
                    brand_id:"",
                    breed_id:"",
                    grade_id:"",
                    port_id:"",
                    attribute_id:"",
                    color_id:"",
                    plate_ruler:"",
                    thickness:"",
                    length:"",
                    cube:"",
                    code:"",
                    layer_number:"",
                    expected_storage_time:"",
                    expected_arrival_time:"",
                    foreign_currency_price:"",
                    cube_price:"",
                    sales_price:"",
                    total_amount:"",
                    remark:"",
                    bale_no:"",
                    wood_type:"",
                    original_bale:"",
                    opening_company_id:"",
                    category:1,//1非洲材, 2北美材
                    pieces:"",//片数 北美材字段
                    width:[]//非洲材字段
                },
                dialogVisibleB:false,
                detailObjectRules:{
                    contract_no:[ { required: true, message: '请填写合同号', trigger: 'blur' }],
                    contract_time:[ { required: true, message: '请填写合同日期', trigger: 'blur' }],
                    breed_id:[ { required: true, message: '请填写品名', trigger: 'blur' }],
                    thickness:[ { required: true, message: '请填写厚度', trigger: 'blur' }],
                    length:[ { required: true, message: '请填写长度', trigger: 'blur' }],
                    cube:[ { required: true, message: '请填写立方', trigger: 'blur' }],
                    bale_no:[ { required: true, message: '请填写数据', trigger: 'blur' }]
                },
                detailObjectRulesBatch:{},
                last_page: 1,
                total: 0,
                list : [],
                selectRow:[],
                tableCol:[	
                    // {colName:"资源状态",colKey:"status_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:this.typeBale==2?"捆包号":"根号",colKey:"bale_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"船名",colKey:"ship_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"堆号",colKey:"heap_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"批次号",colKey:"batch_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:this.typeBale==2?"品名":"树种",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"编码",colKey:"code",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:this.typeBale==2?"厚度":"直径",colKey:"thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"长度",colKey:"length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"层数",colKey:"layer_number",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"千板尺",colKey:"plate_ruler",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"总宽度",colKey:"width_total",colWidth:80,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    // {colName:"码单立方",colKey:"cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"外币单价",colKey:"foreign_currency_price",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"采购单价",colKey:"cube_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"锁定人",colKey:"locker_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"挂牌价",colKey:"sales_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"目的港",colKey:"purpose_port",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"预计入库",colKey:"expected_storage_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"预计到港",colKey:"expected_arrival_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true}
                    // {colName:"到期日",colKey:"expiry_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true}
                    // {colName:"状态",colKey:"status_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"捆包号",colKey:"bale_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"供应商",colKey:"supplier",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"品牌",colKey:"brand",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"品名",colKey:"breed",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"厚度",colKey:"thickness",colWidth:50,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"长度",colKey:"length",colWidth:50,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"片数",colKey:"pieces",colWidth:50,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"总宽度",colKey:"width_total",colWidth:60,isSetWidth:true,isCanClick:true,isShow:true,isHideCanClickColor:true,isHideShowClickImg:true},
                    // {colName:"等级",colKey:"grade",colWidth:50,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"立方",colKey:"cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"千板尺",colKey:"plate_ruler",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    // // {colName:"供应商",colKey:"supplier",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    // // {colName:"合同号",colKey:"contract_no",colWidth:100,isSetWidth:false,isCanClick:false,isShow:true},
                    // // {colName:"提单号",colKey:"bill_lading_no",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"批次号",colKey:"batch_no",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"外币单价",colKey:"foreign_currency_price",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"外币金额",colKey:"foreign_currency_amount",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"采购单价",colKey:"cube_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"总金额",colKey:"total_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"目的港",colKey:"purpose_port",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                tableColA:[
                    {colName:"资源状态",colKey:"status_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isassembleView:true},
                    {colName:"供单号",colKey:"original_bale",colWidth:65,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"外商单号",colKey:"ex_order_no",colWidth:65,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"货权单位",colKey:"opening_company",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"船名",colKey:"ship_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"堆号",colKey:"heap_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"批次号",colKey:"batch_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"属性",colKey:"attribute",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"选色",colKey:"color",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"编码",colKey:"code",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"厚度",colKey:"thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"长度",colKey:"length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"层数",colKey:"layer_number",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"板尺",colKey:"plate_ruler",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"总宽度",colKey:"width_total",colWidth:80,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"码单立方",colKey:"cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"检尺立方",colKey:"check_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"外币名称",colKey:"foreign_currency_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"外币单价",colKey:"foreign_currency_price",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购单价",colKey:"cube_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"锁定人",colKey:"locker_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"挂牌价",colKey:"sales_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"库位",colKey:"storage_location",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"目的港",colKey:"purpose_port",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"汇率",colKey:"foreign_exchange_rate",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"预计入库",colKey:"expected_storage_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"预计到港",colKey:"expected_arrival_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                tableColB:[
                    {colName:"资源状态",colKey:"status_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"根号",colKey:"bale_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"船名",colKey:"ship_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"堆号",colKey:"heap_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"批次号",colKey:"batch_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"树种",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"属性",colKey:"attribute",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"选色",colKey:"color",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"编码",colKey:"code",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"直径",colKey:"thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"长度",colKey:"length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"层数",colKey:"layer_number",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"板尺",colKey:"plate_ruler",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"总宽度",colKey:"width_total",colWidth:80,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"码单立方",colKey:"cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"外币单价",colKey:"foreign_currency_price",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购单价",colKey:"cube_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"锁定人",colKey:"locker_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"挂牌价",colKey:"sales_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"目的港",colKey:"purpose_port",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"预计入库",colKey:"expected_storage_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"预计到港",colKey:"expected_arrival_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                totalObj:{},
                widthObj:{
                    id:"",
                    widthList:[],
                    isCanEdit:false,
                    widthType:2,//2.码单 3.销售
                },
                dialogVisibleWidth:false,
                filterDialogVisible:false,
                filter:"",
                fields:"",
                boardAmericaType:false,
                boardZelkovaType:false,
                boardAfricaType:false,
                categoryRawType:false,
                nationalStandardType:false,
                active : "",
                downloadName:"",
                downloadUCode:"",
            }
        },
        created(){
            this.getSelectList('breed');
            this.getSelectList('brand');
            this.getSelectList('grade');
            this.getSelectList('supplier');
            this.getSelectList('color');
            this.getSelectList('attribute');
            this.getSelectList('opencompany');
            this.purchase_id=sessionStorage.DEMU_ERP_PURCHASE_CONTRACT_ID;
            sessionStorage.removeItem("DEMU_ERP_PURCHASE_CONTRACT_ID")
            this.typeBale=sessionStorage.DEMU_ERP_PURCHASE_CONTRACT_TYPE;
            sessionStorage.removeItem("DEMU_ERP_PURCHASE_CONTRACT_TYPE")
            this.getDetailList()
        },
        methods:{
            filterConfirm(){
                this.getDetailList()
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            addWidthT(){
                this.widthObj.widthList.push(null)
            },
            delWidthT(ind){
                 this.widthObj.widthList.forEach((item,index)=>{
                    if(index==ind){
                        this.widthObj.widthList.splice(index,1)
                    }
                 })
            },
            widthEditT(){
                let obj = new Object();
                obj.id=this.widthObj.id;
                if(this.widthObj.widthType==2){
                    obj.width=this.widthObj.widthList;
                }else{
                    obj.sales_width=this.widthObj.widthList;
                }
                this.postFunc("/erp/purchase.bales.update.width",obj,()=>{
                    this.tip('修改成功','success');
                    this.dialogVisibleWidth=false;
                    this.getDetailList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            backList(){
                this.$root.$children[0].$children[0].showTab({
                    label: "采购订单",
                    name: "采购订单",
                    content: "purchaseList",
                });
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.getDetailList();
            },
            batchEdit(){
                let flag = true;
                this.selectRow.forEach(item=>{
                    if(item.status==1){
                        flag = false;
                    }
                })
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else if(flag==false){
                    this.batchEditType=3;
                    this.detailType=3;
                    this.dialogVisibleB = true;
                    this.detailObject.contract_time=parseInt(this.info.contract_time+"000");
                    this.detailObject.contract_no=this.info.contract_no;
                    this.detailObject.supplier_id=this.info.supplier_id;
                    this.detailObject.purchase_id=this.purchase_id;
                }
                else{
                    this.batchEditType=3;
                    this.detailType=3;
                    this.dialogVisible=true;
                    this.detailObject.contract_time=parseInt(this.info.contract_time+"000");
                    this.detailObject.contract_no=this.info.contract_no;
                    this.detailObject.supplier_id=this.info.supplier_id;
                    this.detailObject.purchase_id=this.purchase_id;
                }
            },
            batchDel(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.getTableDelete(arr)
                }
            },
            delWidth(ind){
                 this.detailObject.width.forEach((item,index)=>{
                     if(index==ind){
                         this.detailObject.width.splice(index,1)
                     }
                 })
            },
            addWidth(){
                this.detailObject.width.push(null)
            },
            add(){
                this.$refs["detailObjectForm"].validate((valid) => {
                    if (valid) {
                        let contract_time = this.detailObject.contract_time;
                        let expected_storage_time = this.detailObject.expected_storage_time;
                        let expected_arrival_time = this.detailObject.expected_arrival_time;
                        this.detailObject.contract_time=this.formatTimeZero(this.detailObject.contract_time);
                        this.detailObject.expected_storage_time=this.formatTimeZero(this.detailObject.expected_storage_time);
                        this.detailObject.expected_arrival_time=this.formatTimeZero(this.detailObject.expected_arrival_time);
                        this.detailObject.wood_type = this.info.wood_type;
                        if(this.detailType==2){
                            this.postFuncLoading("/erp/purchase.bales.create",this.detailObject,()=>{
                                this.dialogVisible = false;
                                this.dialogVisibleB = false;
                                this.tip('新增成功','success');
                                this.getDetailList();
                            },error=>{
                                this.detailObject.contract_time = contract_time;
                                this.detailObject.expected_storage_time = expected_storage_time;
                                this.detailObject.expected_arrival_time = expected_arrival_time;
                                this.tip(error.data.message,"warning")
                            },()=>{
                                this.detailObject.contract_time = contract_time;
                                this.detailObject.expected_storage_time = expected_storage_time;
                                this.detailObject.expected_arrival_time = expected_arrival_time;
                            })
                        }else{
                            if(this.batchEditType==3){
                                let arr = new Array();
                                this.selectRow.forEach(item=>{
                                    arr.push(item.id)
                                })
                                this.detailObject.id=arr;
                            }
                            this.postFuncLoading("/erp/purchase.bales.update",this.detailObject,()=>{
                                this.dialogVisible = false;
                                this.dialogVisibleB = false;
                                this.tip('修改成功','success');
                                this.getDetailList();
                            },error=>{
                                this.detailObject.contract_time = contract_time;
                                this.detailObject.expected_storage_time = expected_storage_time;
                                this.detailObject.expected_arrival_time = expected_arrival_time;
                                this.tip(error.data.message,"warning")
                            },()=>{
                                this.detailObject.contract_time = contract_time;
                                this.detailObject.expected_storage_time = expected_storage_time;
                                this.detailObject.expected_arrival_time = expected_arrival_time;
                            })
                        }
                    } else {
                        return false;
                    }
                });
            },
            getDetailList(){
                this.tableColCopy = this.$deepClone(this.tableCol =this.tableColA);
                this.params.purchase_id=this.purchase_id;
                this.tableLoading = true;
                this.$postColumnList("/erp/purchase.bales.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.list.last_page);
                    // this.params.page=parseInt(res.data.data.list.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.list.total);
                    this.totalObj=res.data.data.total;
                    this.list=res.data.data.list.data;
                    this.info=res.data.data.info;
                    this.list.forEach((item,index)=>{
                        // this.list[index].plate_ruler=this.keepLimit(item.plate_ruler)
                        if(item.expected_storage_time!=0){
                            this.list[index].expected_storage_time = this.formatTime(item.expected_storage_time+"000")
                        }else{
                            this.list[index].expected_storage_time = "";
                        }
                        if(item.expected_arrival_time!=0){
                            this.list[index].expected_arrival_time = this.formatTime(item.expected_arrival_time+"000")
                        }else{
                            this.list[index].expected_arrival_time = "";
                        }
                        if(item.tag==1){
                            item.isDialogViewAdIdHe=true;
                        }
                        if(item.tag==2){
                            item.isDialogViewAdIdChai=true;
                        }
                        if(item.tag==3){
                            item.isDialogViewTranslate_id=true;
                        }
                        // this.list[index].width_total=parseInt(item.width_total)
                        // item.isEdit=true;
                        // item.isDelete=true;
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        // this.pl((this.fields.indexOf(","+item.colKey+",")!=-1)+"  "+item.colKey)
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="original_thickness"){
                            if(this.fields.indexOf(",thickness,")!=-1){
                                item.isShow=true;
                            }
                        }
                        if(item.colKey=="original_width_total"){
                            if(this.fields.indexOf(",width_total,")!=-1){
                                item.isShow=true;
                            }
                        }
                        if(item.colKey=="original_cube"){
                            if(this.fields.indexOf(",cube,")!=-1){
                                item.isShow=true;
                            }
                        }
                        if(item.colKey=="original_length"){
                            if(this.fields.indexOf(",length,")!=-1){
                                item.isShow=true;
                            }
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            rowClick(obj){
                if(obj.name=="width_total"){
                    this.list.forEach(item=>{
                        if(item.id==obj.id){
                            this.widthObj.id=item.id
                            this.widthList = item.width;
                            this.dialogVisibleWidth = true;
                        }
                    })
                }
                // this.dialogVisibleWidth=true;
                // this.list.forEach(item=>{
                //     if(item.id==obj.id){
                //         this.widthObj.id=item.id
                //         if(obj.name=="width_total"){
                //             this.widthObj.widthList=item.width;
                //             if(item.isEdit==1){
                //                 this.widthObj.isCanEdit=true;
                //             }else{
                //                 this.widthObj.isCanEdit=false;
                //             }
                //         }
                //     }
                // })
            },
            getTableDelete(id){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    let arr = new Array();
                    if(typeof(id)=="number"){
                        arr.push(id)
                    }else{
                        arr=id;
                    }
                    this.postFuncLoading("/erp/purchase.bales.delete",{id:arr},()=>{
                        this.tip('删除成功','success');
                        this.getDetailList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getTableSee(id){
                this.pl(id)
            },
            getTableEdit(id){
                this.postFunc("/erp/purchase.bales.detail",{id:id},res=>{
                    this.batchEditType=2;
                    this.detailType=3;
                    this.dialogVisible=true;
                    this.detailObject=res.data.data;
                    this.detailObject.contract_no=this.info.contract_no;
                    res.data.data = this.clearZero(res.data.data)
                    if(this.detailObject.contract_time!=0){
                        this.detailObject.contract_time=parseInt(this.info.contract_time+"000");
                    }
                    if(res.data.data.expected_storage_time!=0){
                        this.detailObject.expected_storage_time=parseInt(res.data.data.expected_storage_time+"000");
                    }
                    else{
                        this.detailObject.expected_storage_time = "";
                    }
                    if(res.data.data.expected_arrival_time!=0){
                        this.detailObject.expected_arrival_time=parseInt(res.data.data.expected_arrival_time+"000");
                    }else{
                        this.detailObject.expected_arrival_time = "";
                    }

                    // this.detailObject.expected_storage_time=parseInt(res.data.data.expected_storage_time+"000");
                    // this.detailObject.expected_arrival_time=parseInt(res.data.data.expected_arrival_time+"000");
                    // this.detailObject.plate_ruler=this.keepLimit(res.data.data.plate_ruler);
                    // this.detailObject.supplier_id=this.info.supplier_id;
                    this.detailObject.purchase_id=this.purchase_id;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getRow(row){
                this.selectRow=row;
            },
            handleSuccess(res) {
                this.file_url = res.data.base_url;
				this.$refs.upload_path.clearFiles();
                this.tip('文件上传成功', 'success');
                //this.importFile();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },
            openimport(){
                this.boardAmericaType=this.info.tpl_code=="pur_america_import"?true:false,
                this.boardZelkovaType=this.info.tpl_code=="pur_america_import"?true:false,
                this.boardAfricaType=this.info.tpl_code=="pur_africa_import"?true:false,
                this.categoryRawType=this.info.tpl_code=="pur_wood_import"?true:false,
                this.nationalStandardType = this.info.tpl_code=="pur_africa_import"?true:false,
                                                                //this.boardAfricaType?3
                this.active = this.boardAmericaType?1: this.boardAfricaType?3:this.boardZelkovaType?2:this.nationalStandardType?5:this.categoryRawType?4:this.nationalStandardType?5:"";
                this.downloadName=this.boardAmericaType?"北美材码单模板":this.boardZelkovaType?"榉木码单模板":this.boardAfricaType?"非洲材码单模板":this.categoryRawType?"原木码单模板":this.nationalStandardType?"国标/非洲材码单模板":"";
                this.downloadUCode=this.boardAmericaType?"pur_america_import":this.boardZelkovaType?"pur_zelkova_import":this.boardAfricaType?"pur_africa_import":this.categoryRawType?"pur_wood_import":this.nationalStandardType?"pur_ds_import":"";
                // this.downloadUUrl=this.boardAmericaType?"/erp/import.qc.america":this.boardZelkovaType?"/erp/import.qc.zelkova":this.boardAfricaType?"/erp/import.qc.africa":this.categoryRawType?"/erp/import.qc.wood":""
                this.importDialogVisible=true;
            },
            importFile(){
                this.analysis('/erp/import.analysis',this.file_url,this.downloadUCode,this.info.purchase_id,"",response=>{
                    if (response.data.code == 0) {
                        this.tip("上传成功","success")
                        this.getDetailList()
                        this.importDialogVisible=false;
                    }else{
                        this.tip(response.data.message,"warning")
                    }
                })
            },
            downTemplete(){
                this.exportFile(this.downloadUCode,this.info.contract_no,this.info.purchase_id,"",response=>{
					const content = response.data;
                    const blob = new Blob([content], {type: response.headers['content-type']});
                    const fileName =this.downloadName+this.getDownloadTempleteTime(new Date())+'.xlsx';
					// const fileName = (this.typeBale==2?'板材码单上传模板':'原木码单上传模板')+this.getDownloadTempleteTime(new Date())+'.xlsx';
					if ('download' in document.createElement('a')) { // 非IE下载
						const elink = document.createElement('a');
						elink.download = fileName;
						elink.style.display = 'none';
						elink.href = URL.createObjectURL(blob);
						document.body.appendChild(elink);
						elink.click();
						URL.revokeObjectURL(elink.href); // 释放URL 对象
						document.body.removeChild(elink);
					} else { // IE10+下载
						navigator.msSaveBlob(blob, fileName);
					}
                })
            },
            getOss(){
                let self = this;
                return new Promise((resolve, reject) =>{
                    window.axios.post(window.oss_url+"/tool/v1/oss.policy.get",{
                        operate_code : "shop-excel"
                    }).then((response) => {
                        if(response.data.code == 0){
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key : self.oss.dir + "${filename}",
                                policy : self.oss.policy,
                                OSSAccessKeyId : self.oss.accessid,
                                success_action_status : "200",
                                callback : self.oss.callback,
                                signature : self.oss.signature,
                                'Cache-Control' : self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(()=>{
                        reject();
                    })
                })
            }
        },
        watch:{
            "params.page":function(){
                this.getDetailList();
            },
            "params.per_page":function(){
                this.getDetailList();
            },
            "active":function(val){
                if(val==1){
                    this.downloadName="北美材码单模板";
                    this.downloadUCode="pur_america_import";
                }else if(val==2){
                    this.downloadName="榉木码单模板";
                    this.downloadUCode="pur_zelkova_import";
                }else if(val==3){
                    this.downloadName="非洲材码单模板";
                    this.downloadUCode="pur_africa_import";
                }else if(val==4){
                    this.downloadName="原木码单模板";
                    this.downloadUCode="pur_wood_import";
                }else if(val==5){
                     this.downloadName="国标/非洲材码单模板";
                    this.downloadUCode="pur_ds_import";
                }
            },
            "dialogVisible":function(val){
                if(!val){
                    this.detailObject=this.resetJson(this.detailObject)
                    this.detailObject.width=[];
                    this.detailObject.wood_type = this.info.wood_type;
                }
            },
            "dialogVisibleWidth":function(val){
                if(!val){
                    this.widthObj={id:"",widthList:[],widthType:2}
                }
            },
            typeBale:function(val){
                this.tableCol = this.tableColA
            }
        }
    }
</script>
